<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      resizable
      border
      :editConfig="{
        trigger: 'manual',
        mode: 'row',
        showStatus: true,
      }"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('INDEX.table_label_shipment_order_batch_box') || '发运单批次箱'
            }}</span>
          </div>
        </slot>
      </template>
      <template v-slot:boxPriceAmount="{ row }">
        <span>{{ row.boxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:boxSalePriceAmount="{ row }">
        <span
          >{{ row.boxSalePriceAmount || 0 }} {{ row.v_salesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:batchBoxPriceAmount="{ row }">
        <span>{{ row.batchBoxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:batchBoxSalePriceAmount="{ row }">
        <span
          >{{ row.batchBoxSalePriceAmount || 0 }}
          {{ row.v_salesCurrencyUnit }}</span
        >
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    height: { type: Number, default: 300 },
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentBatchCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },

      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('INDEX.order_package_packingType') || '装箱方式',
          field: 'v_packingType',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
          field: 'identifyGoodsNo',
          align: 'center',
          headerAlign: 'center',
          width: 200,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_goodsNameDisplay') || '产品中文说明',
          field: 'goodsNameDisplay',
          headerAlign: 'center',
          align: 'left',
          minWidth: 200,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_goods_spec_display') || '规格尺寸说明',
          field: 'goodsSpecDisplay',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_batchBoxGoodsQty') || '产品数量',
          field: 'batchBoxGoodsQty',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.order_form_batch_label_totBoxQty') || '箱数',
          field: 'batchBoxQty',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.form_label_boxQty') || '已入柜箱数',
          field: 'containerBoxQty',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title:
            this.$l('INDEX.table_label_box_net_weight') || '单箱净重（kg）',
          field: 'boxNetWeight',
          align: 'center',
          headerAlign: 'center',
          width: 130,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title:
            this.$l('INDEX.table_label_box_gross_weight') || '单箱毛重（kg）',
          field: 'boxGrossWeight',
          align: 'center',
          headerAlign: 'center',
          width: 130,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_boxGoodsQty') || '单箱产品数量',
          field: 'boxGoodsQty',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.form_totalNetWeight') || '总净重(kg)',
          field: 'batchBoxNetWeight',
          align: 'center',
          headerAlign: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.form_totalGrossWeight') || '总毛重(kg)',
          field: 'batchBoxGrossWeight',
          align: 'center',
          headerAlign: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.form_totalPriceAmount') || '工厂金额',
          field: 'batchBoxPriceAmount',
          align: 'center',
          headerAlign: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: {
            default: 'batchBoxPriceAmount',
          },
        },
        {
          title: this.$l('INDEX.form_shipmentSalePrice') || 'ABS金额',
          field: 'batchBoxSalePriceAmount',
          align: 'center',
          headerAlign: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: {
            default: 'batchBoxSalePriceAmount',
          },
        },
      ],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff',
      }
    },
    loadData() {
      if (!this.shipmentBatchCode) return
      this.loading = true
      this.$api
        .shipmentBatchBoxListApi({
          shipmentBatchCode: this.shipmentBatchCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
          this.data.forEach((item) => {
            item.boxQtyOld = item.boxQty
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
